export class InsuredMdl{
    public IqamaNo:string;
    public DOB:string;
    public Email:string;
    public Mobile:string;
    public OTP:string;
    public VehicleUsageType:string;
   
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/InsuredMdl.ts